import { Capacitor } from "@capacitor/core";

// Native-only setup: status-bar styling + hide the splash once React is up.
// On the web this is a no-op (isNativePlatform() === false).
export async function initNative() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    // Light background => dark status-bar icons/text.
    await StatusBar.setStyle({ style: Style.Light });
    if (Capacitor.getPlatform() === "android") {
      await StatusBar.setBackgroundColor({ color: "#F5F3EE" });
    }
  } catch (e) {
    /* status bar plugin unavailable */
  }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch (e) {
    /* splash plugin unavailable */
  }
}

// Gentle tap on page turns. Native uses the Haptics plugin; the web falls
// back to the Vibration API where available (desktop browsers ignore it).
export async function hapticTick() {
  if (Capacitor.isNativePlatform()) {
    try {
      const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
      await Haptics.impact({ style: ImpactStyle.Light });
      return;
    } catch (e) {
      /* fall through */
    }
  }
  try {
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(8);
  } catch (e) {
    /* vibration unavailable */
  }
}

// Optional portrait lock (native only). lock(true) pins portrait; lock(false)
// restores free rotation.
export async function setPortraitLock(locked) {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { ScreenOrientation } = await import("@capacitor/screen-orientation");
    if (locked) await ScreenOrientation.lock({ orientation: "portrait" });
    else await ScreenOrientation.unlock();
  } catch (e) {
    /* orientation plugin unavailable */
  }
}
